import React, { useEffect, useState } from "react";

/** Sidebar preview — simplified SVG inspired by the longform text-dial clock. */
export default function LongformAnalogPreviewSvg() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 500);
    return () => clearInterval(id);
  }, []);
  const now = new Date();
  const ms = now.getMilliseconds() / 1000;
  const sec = now.getSeconds() + ms;
  const min = now.getMinutes() + sec / 60;
  const hr = (now.getHours() % 12) + min / 60;
  const th = (-Math.PI / 2 + (hr / 12) * 2 * Math.PI) * (180 / Math.PI);
  const tm = (-Math.PI / 2 + (min / 60) * 2 * Math.PI) * (180 / Math.PI);
  const ts = (-Math.PI / 2 + (sec / 60) * 2 * Math.PI) * (180 / Math.PI);

  return (
    <svg
      viewBox="0 0 300 300"
      className="de-clock-longform-svg-preview"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="lfFace" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#39454b" />
          <stop offset="22%" stopColor="#39454b" />
          <stop offset="100%" stopColor="#101017" />
        </linearGradient>
      </defs>
      <circle cx="150" cy="150" r="138" fill="url(#lfFace)" stroke="#39454b" strokeWidth="10" />
      <g transform={`translate(150,150) rotate(${th})`}>
        <line x1="0" y1="0" x2="80" y2="0" stroke="#b7ddf0" strokeWidth="4" strokeLinecap="round" />
      </g>
      <g transform={`translate(150,150) rotate(${tm})`}>
        <line x1="0" y1="0" x2="120" y2="0" stroke="#b7ddf0" strokeWidth="4" strokeLinecap="round" />
      </g>
      <g transform={`translate(150,150) rotate(${ts})`}>
        <line x1="0" y1="0" x2="130" y2="0" stroke="#b7ddf0" strokeWidth="2" strokeLinecap="round" />
        <ellipse cx="115" cy="0" rx="6" ry="5" fill="none" stroke="#b7ddf0" strokeWidth="1" />
      </g>
      <text x="150" y="72" textAnchor="middle" fill="#fff" fontSize="11" fontFamily="Arial,sans-serif">
        three
      </text>
      <text x="150" y="92" textAnchor="middle" fill="#fff" fontSize="11" fontFamily="Arial,sans-serif">
        forty five
      </text>
      <text x="150" y="232" textAnchor="middle" fill="#fff" fontSize="10" fontFamily="Arial,sans-serif">
        TUE | APR | 07
      </text>
      <circle cx="150" cy="150" r="10" fill="#4c5c64" stroke="#101017" strokeWidth="1" strokeDasharray="2 2" />
    </svg>
  );
}
